import PropTypes from 'prop-types';

import Modal from '../Modal';
import sty from './alert.module.scss';

/**
 * AlertModal — the app's single confirmation / alert dialog, rendered on the
 * shared Modal shell so every prompt matches the design system.
 *
 * `type="1"` is a one-button acknowledgement (success). Anything else is a
 * two-button confirm: `closeFn`/`closeTxt` is the secondary (cancel), `saveFn`/
 * `saveTxt` the primary. `intent` (info|warning|danger) sets the icon and, for
 * danger, a red primary + Cancel-first focus — pass `danger` for destructive
 * prompts (delete, stop). Escape / backdrop click cancel.
 */
function AlertModal(props) {
  const { type, header, closeFn, closeTxt, saveFn, saveTxt, msg, center, className, intent } =
    props;
  const isInfo = type?.toString() === '1';
  const dialogIntent = isInfo ? 'success' : intent || 'warning';

  return (
    <Modal
      className={className}
      center={center}
      width={420}
      intent={dialogIntent}
      title={header}
      ariaLabel={header || msg}
      onClose={closeFn}
      secondaryAction={isInfo ? undefined : { label: closeTxt, onClick: closeFn }}
      primaryAction={
        isInfo ? { label: closeTxt, onClick: closeFn } : { label: saveTxt, onClick: saveFn }
      }
    >
      {msg && <p className={sty.msg}>{msg}</p>}
    </Modal>
  );
}

AlertModal.propTypes = {
  type: PropTypes.string,
  header: PropTypes.string,
  closeFn: PropTypes.func,
  closeTxt: PropTypes.string,
  saveFn: PropTypes.func,
  saveTxt: PropTypes.string,
  msg: PropTypes.string,
  center: PropTypes.bool,
  className: PropTypes.string,
  intent: PropTypes.oneOf(['info', 'warning', 'danger']),
};

export default AlertModal;
